import { defineStore } from 'pinia';
import * as ChoiceApi from '../ChoiceApi';
import {IStatusOptionModel}  from '../Api/Schedule';
import { ref } from 'vue';
import { IAlertInfo, constantAlertIds, IAlertTreeOptionModel } from '../Models/Comments/Alerts';
import _ from 'lodash';

export const useCommentAttributesStore = defineStore('CommentAttributes', () => {

    const alertInfoHierarchy = ref<IAlertInfo[]|undefined>();
    
    const hardCodedAlertOptionsTree: IAlertInfo[] = [
        {id: constantAlertIds.All, name: "All" },
        {id: 200, name: "Billing", children: [
            {id: 99, name: "Patient/Claim Comments" }
        ]},                
        {id: 210, name: "Clinical", children: [
            {id: 100, name: "Patient Loaded into EMR" },
            {id: 98, name: "Superbill Chart Tab" },
            {id: 97, name: "Order Entry Chart Tab" },
        ]},
        {id: constantAlertIds.FrontOffice, name: "Front Office", children: [
            // Add items dynamically
            //{id: 0, name: "Patient Loaded into Scheduler"}
        ]},
    ];

    let frontOfficeStatusOptions: IStatusOptionModel[] = [];
        
    async function initAlertInfoHierarchy(): Promise<IAlertInfo[]|undefined>
    {
        const tempAlertInfoHierarchy = _.clone(hardCodedAlertOptionsTree);

        const frontOfficeOption = tempAlertInfoHierarchy.find(item => item.id === constantAlertIds.FrontOffice);
        if (0 === frontOfficeOption?.children?.length)
        {
            // Add 'status' options under 'Front Office'
            frontOfficeStatusOptions = await ChoiceApi.schedule.statusOptions();

            // Add a constant item
            frontOfficeOption?.children?.push({id:0, name: "Patient Loaded into Scheduler", parent: frontOfficeOption });

            // Add the appointment options
            for(const statusOption of frontOfficeStatusOptions.filter(item => item.isActive))
            {
                frontOfficeOption?.children?.push({name: statusOption.appointment_status_description, id: statusOption.appointment_status_id, parent: frontOfficeOption });
            }
        }
        return tempAlertInfoHierarchy;
    }

    // Use for alert selection tree
    async function getAlertTree(): Promise<IAlertTreeOptionModel[]>
    {
        // Function to itterate items
        function initAttributeOption(options: IAlertInfo[]): IAlertTreeOptionModel[]
        {
            return options.map<IAlertTreeOptionModel>(opt => { 
                const alertOption: IAlertTreeOptionModel = { 
                    id: opt.id, 
                    selected: false, 
                    name: opt.name };
                if (opt.children)
                    alertOption.children = initAttributeOption(opt.children);
                return alertOption;
            });
        }

        const resp = await initAlertInfoHierarchy();
        if (resp)
        {
            return initAttributeOption(resp);
        }
        return [];
    }

    // Get the alert option
    //  Make sure to call initAlertInfoHierarchy before calling this 
    function getAlertInfoById(id: number): IAlertInfo | undefined {
        if (!alertInfoHierarchy.value)
        {
            console.log("It looks like initAlertInfoHierarchy wasn't called before calling getAlertInfoById()");
            return;
        }

        for(const option of alertInfoHierarchy.value)
        {
            if (option.id === id)
                return option;

            for(const childOption of option.children ?? [])
            {
                if (childOption.id === id)
                    return childOption;
            }
        }
    }

    return { alertInfoHierarchy, initAlertInfoHierarchy, getAlertTree, getAlertInfoById };
});
